<template>
  <div class="gw-sensor">
    <template v-for="(item, index) in sensorList">
      <el-row :gutter="20" :key="index" v-if="index % 2 === 0">
        <el-col :xs="24" :lg="12" v-for="i in [0, 1]" :key="i">
          <div class="grid-content common-border" v-if="sensorList[index + i]">
            <div class="sensor-info">
              <div class="name">{{ sensorList[index + i].name }}</div>
              <div class="value">
                {{ realDataObj[sensorList[index + i].prop] }}
              </div>
              <div class="unit">
                {{ sensorList[index + i].unitName || '' }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    sensorList: {
      type: Array,
      default: () => []
    },
    realDataObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  methods: {},
  components: {}
};
</script>

<style lang="scss">
.gw-sensor {
  .el-row {
    margin-bottom: 10px;
    .grid-content {
      height: 150px;
      border: 1px solid rgb(96, 118, 173);
      margin-bottom: 20px;
      .sensor-info {
        //   text-align: center;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        .name,
        .unit {
          font-size: 18px;
        }
        .value {
          color: #00e401;
          font-size: 22px;
          font-weight: bold;
        }
      }
    }
  }

  .common-border {
    height: 100%;
    padding: 2px;
    background-image: url('~@/assets/image/lt.png'), url('~@/assets/image/rt.png'),
      url('~@/assets/image/lb.png'), url('~@/assets/image/rb.png'),
      url('~@/assets/image/linelight.png');
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
    background-position: top left, top right, bottom left, bottom right, center -5px;

    .comp3-content {
      height: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
